import makeService from './api';

export default makeService('section_parameters');
